import React from 'react'
import Photo from "../../../../Assests/Products/Hospitalmang/Account.png"
const EMRInteroperability = () => {
    return (
        <div className="CompareAnalysis-2" data-aos="zoom-in-left" style={{ width: "90%", margin: "auto" }}>
            <div className="CompareAnalysis-Def">
                <h2>

                    EMR Interoperability      </h2>
                <p>
                    EMRs promote data exchange between various healthcare providers, improving care coordination and ensuring comprehensive patient management1.
                </p>

            </div>
            <div className="CompareAnalysis-Photo">
                <img src={Photo} alt="" />
            </div>
        </div>
    )
}

export default EMRInteroperability